import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useCart = () => useQuery({ queryKey: [`cart`], queryFn: async () => {
    const callback = await API.get(`/store/cart`)
    return callback?.data
}, staleTime: 3000, gcTime: 1000 * 60 * 10 })

export default useCart